import { Spinner } from 'react-bootstrap';

const ActivityIndicator = () => (<Spinner animation="border" role="status" size="sm" />);

export default ActivityIndicator;
